import { LAYOUTS, ModalAlignmentEnum, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { heightMap } from "../../configs/height";
import { ACTION } from "./types";
import { goBack } from "./actions";
import { isMobile } from "../../configs/utils";
import { CheckLimitInfoType } from "../../configs/constants";
const _isMobile = isMobile();
export const template = async (title, type = CheckLimitInfoType.TOTAL_AVAILABLE_LIMIT) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_INFO,
        type: LAYOUTS.MODAL,
        style: {
            isPartnerPlatform: true,
            height: type === CheckLimitInfoType.TOTAL_AVAILABLE_LIMIT ?
                heightMap[ROUTE.CHECK_LIMIT_INFO] : 150,
            alignment: _isMobile ?
                ModalAlignmentEnum.BOTTOM :
                ModalAlignmentEnum.CENTER
        },
        widgets: [
            { id: 'CheckLimitInfoRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitInfoRootStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            // alignItems: StackAlignItems.center,
            padding: {
                all: SizeTypeTokens.XL
            },
            maxWidth: _isMobile ? 1024 : 360,
            widgetItems: [
                { id: 'CheckLimitInfoRootStack1', type: WIDGET.STACK },
                type === CheckLimitInfoType.TOTAL_AVAILABLE_LIMIT ? { id: 'CheckLimitInfoRootStack2', type: WIDGET.STACK } : {},
                type === CheckLimitInfoType.DEMAT ? { id: 'CheckLimitInfoRootStack2_Demat', type: WIDGET.STACK } : {},
                type === CheckLimitInfoType.LOCKED ? { id: 'CheckLimitInfoRootStack2_Locked', type: WIDGET.STACK } : {},
                type === CheckLimitInfoType.UNAPPROVED ? { id: 'CheckLimitInfoRootStack2_Unapproved', type: WIDGET.STACK } : {},
            ],
        },
        CheckLimitInfoRootStack2_Unapproved: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'CheckLimitInfoRootStack2_Unapproved_T1', type: WIDGET.TEXT },
            ]
        },
        CheckLimitInfoRootStack2_Unapproved_T1: {
            label: 'Unapproved funds are a type of mutual funds that are ' +
                'currently not supported by our lending partner ' +
                'for credit lines. For more information, please contact support at +91 6364465608.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 4,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2_Locked: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'CheckLimitInfoRootStack2_Locked_T1', type: WIDGET.TEXT },
            ]
        },
        CheckLimitInfoRootStack2_Locked_T1: {
            label: 'Locked ELSS mutual funds are not eligible for a credit limit due to the lock-in period associated with them.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 4,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2_Demat: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'CheckLimitInfoRootStack2_Demat_T1', type: WIDGET.TEXT },
            ]
        },
        CheckLimitInfoRootStack2_Demat_T1: {
            label: 'Demat mutual funds are currently not supported for credit lines by Volt Money. We will notify you when Demat mutual funds become eligible for credit lines.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 4,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            // justifyContent: StackJustifyContent.spaceBetween,
            // alignItems: StackAlignItems.center,
            widgetItems: [
                { id: 'CheckLimitInfoRootStack2T1', type: WIDGET.TEXT },
                { id: 'CheckLimitInfoRootStack2Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitInfoRootStack2T2', type: WIDGET.TEXT },
                { id: 'CheckLimitInfoRootStack2Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitInfoRootStack2T3', type: WIDGET.TEXT },
                { id: 'CheckLimitInfoRootStack2Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitInfoRootStack2T4', type: WIDGET.TEXT },
                { id: 'CheckLimitInfoRootStack2Space0', type: WIDGET.SPACE },
                { id: 'CheckLimitInfoRootStack2Button', type: WIDGET.BUTTON },
            ]
        },
        CheckLimitInfoRootStack2T1: {
            label: 'Eligible credit limit is based on the current value of your mutual fund investments.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 3,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2T2: {
            label: 'Factors considered for calculating credit limit include investment portfolio of the mutual fund, historical performance, and market fluctuation risks.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 3,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2T3: {
            label: 'We provide up to 90% of the value for debt mutual funds, and up to 50% of the value for equity mutual funds.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 3,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack2T4: {
            label: 'Ineligible mutual funds are not included for calculating credit limit. Reasons for ineligibility include locked units, ' +
                'demat mutual funds, and funds that are not approved for pledging by lenders.',
            fontWeight: "400",
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.XS,
            lineHeight: 18,
            numberOfLines: 6,
            color: ColorTokens.Grey_Charcoal
        },
        CheckLimitInfoRootStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            alignItems: StackAlignItems.center,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitInfoRootStackT1', type: WIDGET.TEXT },
                { id: 'CheckLimitInfoRootCloseStack', type: WIDGET.STACK },
            ]
        },
        CheckLimitInfoRootCloseStack: {
            type: StackType.column,
            width: StackWidth.CONTENT,
            widgetItems: [
                { id: 'CheckLimitInfoRootCloseIcon', type: WIDGET.IMAGE },
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_INFO,
                type: ACTION.GO_BACK,
                payload: {}
            }
        },
        CheckLimitInfoRootStack2Button: {
            type: ButtonTypeTokens.LargeSoftFilled,
            label: 'Ok, got it!',
            fontSize: FontSizeTokens.SM,
            width: ButtonWidthTypeToken.FULL,
            action: {
                routeId: ROUTE.CHECK_LIMIT_INFO,
                type: ACTION.GO_BACK,
                payload: {}
            }
        },
        CheckLimitInfoRootStackT1: {
            label: `${title ? title : 'Test'}`,
            fontWeight: "700",
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.MD,
            lineHeight: 24
        },
        CheckLimitInfoRootCloseIcon: {
            uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/CloseIcon_1.svg',
            width: 32,
            height: 32,
        },
        CheckLimitInfoRootStack2Space0: {
            size: SizeTypeTokens.XL
        }
    }
});
export const CheckLimitInfo = {
    onLoad: async ({ removeWidgets }, { title, type }) => {
        await removeWidgets(ROUTE.CHECK_LIMIT_INFO, [
            { id: 'CheckLimitInfoRootStack', type: WIDGET.STACK }
        ]);
        const tell = "";
        return Promise.resolve(template(title, type));
    },
    actions: {
        // [ACTION.ON_LOAD]: onLoad,
        // [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GO_BACK]: goBack
    },
};
